import './TrendingBrands.scss';

import classnames from 'classnames';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Slider from 'react-slick';

import {
	facetSelected,
	facetToggled,
	updateDismissFiltersUrl,
} from '../../../actions/lister-actions';
import { useIsXSmallAndAbove } from '../../../hooks/mediaQueries';
import TrendingBrandsFacet from './TrendingBrandsFacet';

const buttonStyles = {
	top: '50%',
	transform: 'translateY(-50%)',
};
const buttonClasses =
	'absolute bg-white border border-gray-30 border-solid flex h-10 items-center justify-center rounded-full shadow-2dp w-10 z-10';
const buttonIconClasses = '-mt-px ico ico-lg text-cta-action';

const closeToolTip = () => {
	document.dispatchEvent(new CustomEvent('closeTrendingBrandsTooltip'));
};

const Arrow = ({ className, style, iconClasses, onClick }) => (
	<button
		type="button"
		className={classnames(buttonClasses, className)}
		style={{
			...buttonStyles,
			...style,
		}}
		onClick={() => {
			closeToolTip();
			onClick();
		}}>
		<i className={classnames(buttonIconClasses, iconClasses)} />
	</button>
);

const NextArrow = (props) => (
	<Arrow
		{...{
			...props,
			style: { right: '-1rem' },
			iconClasses: 'ico-chevron-right ml-1',
		}}
	/>
);

const PrevArrow = (props) => (
	<Arrow
		{...{ ...props, style: { left: '-1rem' }, iconClasses: 'ico-chevron-left' }}
	/>
);

const TrendingBrandsCarousel = ({ availableBrands, isReady }) => {
	const {
		dismissFiltersUrl,
		pageTitle,
		adobeTagging: { CategorisationTagViewModel: { MainCategory } = {} } = {},
	} = useSelector((state) => state);

	const dispatch = useDispatch();

	const handleChange = (evt, facetValue, id) => {
		evt.preventDefault();
		evt.stopPropagation();

		dispatch(facetToggled(facetValue, true));

		const facetData = {
			facetTypeHeader: 'Brand',
			facetTypePosition: null,
			facetValue: facetValue,
			facetValuePosition: id,
			pageUrl: dismissFiltersUrl,
			pageTitle: pageTitle,
			storeSelectedFacets: null,
			category: MainCategory,
			exposedFacets: true,
		};

		dispatch(facetSelected(facetData));

		dispatch(updateDismissFiltersUrl(facetValue.Url));
	};

	const itemsInCarousel = availableBrands?.length;

	const isXSmallAndAbove = useIsXSmallAndAbove();

	const carouselSettings = {
		className: 'trending-brands__carousel pt-1 pr-1 -mr-4',
		infinite: false,
		speed: 250,
		slidesToShow: itemsInCarousel,
		slidesToScroll: 1,
		arrows: isReady,
		nextArrow: <NextArrow />,
		prevArrow: <PrevArrow />,
		variableWidth: !isXSmallAndAbove,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 2,
					arrows: false,
					nextArrow: null,
					prevArrow: null,
				},
			},
			{
				breakpoint: 989,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 1240,
				settings: {
					slidesToShow: itemsInCarousel < 4 ? itemsInCarousel : 4,
				},
			},
		],
	};

	return (
		<Slider {...carouselSettings}>
			{availableBrands?.map((facet, idx) => (
				<TrendingBrandsFacet
					key={facet.Name}
					{...{ facet, idx, itemsInCarousel, isReady, handleChange }}
				/>
			))}
		</Slider>
	);
};

export default TrendingBrandsCarousel;
